import { inject, Injectable } from '@angular/core';
import {
  BaseWebsocketMessage,
  SubWebsocketMessageRequest,
  WebsocketEntTypes,
  WebSocketService,
  WSEntityManager,
} from '@qtek/core/websockets-core';
import { filter, Observable, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WorkflowStateService {
  private readonly webSocketService = inject(WebSocketService);

  entityName = 'workflowState' as WebsocketEntTypes;
  wsManager = new WSEntityManager(this.webSocketService, this.entityName);

  readonly webSocketIsAlive$ = this.webSocketService.getWebSocketIsAlive$();

  subscribe(
    payload: Omit<SubWebsocketMessageRequest, 'ent' | 'op'>
  ): Observable<BaseWebsocketMessage> {
    return this.wsManager.subscribeEntity(payload);
  }

  getHistoryByRun(runId: string, mysid: string): void {
    this.wsManager.get({ id: runId, mysid, view: 'history' });
  }

  getHistoryByRunResponse(mysid: string): Observable<BaseWebsocketMessage> {
    return this.webSocketService.getWebSocket$().pipe(
      filter((msg: any) => msg.ent === this.entityName && msg.mysid === mysid),
      take(1)
    );
  }
}
